import { buildDataTableCols, type DataTableCol } from '@/components/custom/erp/data-table-v2';
import type { TaiKhoanNganHang } from '@/types/schemas';

type BankAccountRow = TaiKhoanNganHang & {
  unit_id_data?: {
    ma_unit?: string | null;
  } | null;
};

const BANK_ACCOUNT_COLS = (handleOpenViewForm: (row: BankAccountRow) => void): DataTableCol<BankAccountRow>[] => [
  {
    field: 'ma_unit',
    headerName: 'Đơn vị',
    width: 120,
    valueGetter: row => row.unit_id_data?.ma_unit || ''
  },
  {
    field: 'tknh',
    headerName: 'Mã tài khoản',
    width: 140,
    valueGetter: row => row.tknh,
    renderCell: params => (
      <button
        type='button'
        className='cursor-pointer hover:text-blue-600 hover:underline'
        onClick={event => {
          event.stopPropagation();
          handleOpenViewForm(params.row);
        }}
      >
        {params.row.tknh}
      </button>
    )
  },
  {
    field: 'name',
    headerName: 'Số tài khoản ngân hàng',
    width: 180,
    valueGetter: row => row.name
  },
  {
    field: 'ma_ngan_hang',
    headerName: 'Ngân hàng',
    width: 140,
    valueGetter: row => row.ma_ngan_hang_data?.ma_ngan_hang || ''
  },
  {
    field: 'ten_ngan_hang',
    headerName: 'Tên ngân hàng',
    width: 220,
    valueGetter: row => row.ma_ngan_hang_data?.ten_ngan_hang || ''
  },
  {
    field: 'chu_tk',
    headerName: 'Tên chủ ngân hàng',
    width: 200,
    valueGetter: row => row.chu_tk
  },
  {
    field: 'tk',
    headerName: 'Tài khoản kế toán',
    width: 130,
    valueGetter: row => row.account_model_data?.code || ''
  }
];

export const getBankAccountColumns = (handleOpenViewForm: (row: BankAccountRow) => void) =>
  buildDataTableCols(BANK_ACCOUNT_COLS(handleOpenViewForm));
